module.exports = __webpack_public_path__ + "img/48_23.3eff3a88.png";